/***
 * Created on 2023/10/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import InviteSignup from '../component/signup/invite_signup';


export default InviteSignup;